export default function stickyHeader() {
  document.querySelectorAll(".sticky-header").forEach((el) => {
    const onScroll = () => {
      if (window.scrollY > el.offsetHeight) {
        el.classList.add("bg-white");
      } else {
        el.classList.remove("bg-white");
      }
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  });
}
